// extracted by mini-css-extract-plugin
export default {"flexp":"addaddress_flexp__Cie4T","flex":"addaddress_flex__8yrwS","box":"addaddress_box__sE4JI"};